/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { translateElementChildren } from 'utils/translation';

const H6 = ({ children, translationKey, defaultText, ...rest }) => {
  return (
    <h6 {...rest}>
      {translateElementChildren(children, translationKey, defaultText)}
    </h6>
  );
};

H6.propTypes = {
  children: PropTypes.node.isRequired,
  translationKey: PropTypes.string,
  defaultText: PropTypes.string,
};

export default H6;
